import React, { useMemo } from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { remapReplies, remapReplyChildren } from '../../_helpers/pdfHelpers'

const ConclusiveMappingSection = ({ serviceOrder }) => {
  const remap = useMemo(() => remapReplyChildren(serviceOrder.replies), [serviceOrder.replies])

  const data = useMemo(() => {
    const result = remapReplies(serviceOrder.replies, remap)
    return result
  }, [remap, serviceOrder.replies])

  return (
    <View noWrap id="15">
      <Text bold size="small">
        15. MAPEAMENTO CONCLUSIVO
      </Text>

      <Separator weight={4} />

      <Table width="100%">
        <TableRow>
          <TableHeadText align="center">Setor</TableHeadText>
          <TableHeadText align="center" width="250px">
            Função
          </TableHeadText>
          <TableHeadText align="center">GHE</TableHeadText>
          <TableHeadText align="center">Apresenta Risco</TableHeadText>
        </TableRow>
        {!!data.atendimento && !!data.atendimento.length && (
          <TableRow>
            <TableColText align="center">ATENDIMENTO</TableColText>
            <TableColText align="center">{data.atendimento.map(e => e.funcao).join(' ')}</TableColText>
            <TableColText align="center">01</TableColText>
            <TableColText align="center">Ausência de Risco</TableColText>
          </TableRow>
        )}
        {data.comercial && data.comercial.length && (
          <TableRow>
            <TableColText align="center">COMERCIAL</TableColText>
            <TableColText align="center">{data.comercial.map(e => e.funcao).join(' ')}</TableColText>
            <TableColText align="center">{data.atendimento.length ? '02' : '01'}</TableColText>
            <TableColText align="center">Ausência de Risco</TableColText>
          </TableRow>
        )}
      </Table>

      <Separator weight={8} />
    </View>
  )
}

export default ConclusiveMappingSection
